import { render, staticRenderFns } from "./package.vue?vue&type=template&id=1e1a60e2&scoped=true"
import script from "./package.vue?vue&type=script&lang=js"
export * from "./package.vue?vue&type=script&lang=js"
import style0 from "./package.vue?vue&type=style&index=0&id=1e1a60e2&prod&scoped=true&lang=css"
import style1 from "./package.vue?vue&type=style&index=1&id=1e1a60e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e1a60e2",
  null
  
)

export default component.exports